import React from "react";
import PropTypes from "prop-types";
import { SVGIcon } from "./../Icons";
import {
  StyledOverlayContainer,
  StyledOverlay,
  StyledButtonWrapper,
  StyledIconContainer,
  StyledDuration,
} from "./styles";

const ButtonPlayOverlay = ({
  context,
  clientContext,
  size = "small",
  label,
}) => {
  return (
    <StyledOverlayContainer>
      <StyledOverlay>
        <StyledButtonWrapper>
          <StyledIconContainer size={size}>
            <SVGIcon
              iconName="playIcon"
              styled={false}
              clientContext={clientContext}
            />
          </StyledIconContainer>
          {label && <StyledDuration>{label}</StyledDuration>}
        </StyledButtonWrapper>
      </StyledOverlay>
    </StyledOverlayContainer>
  );
};

export default ButtonPlayOverlay;

ButtonPlayOverlay.propTypes = {
  /**
   Pixel dimensions of icon
  */
  size: PropTypes.string.isRequired,
  /**
    Label
  */
  label: PropTypes.string
};
